// API Configuration
// This file manages the API base URL for different environments

const API_BASE_URL = process.env.REACT_APP_API_URL || process.env.REACT_APP_API_BASE_URL ||
    (process.env.NODE_ENV === 'production'
        ? 'https://soilsense-smart-fertilizer.onrender.com'
        : 'http://localhost:8000');

export default API_BASE_URL;
